export const isValidUruguayanCI = (ci) => {
  if (!ci) return false;
  const cleaned = ci.replace(/\D/g, '').padStart(8, '0');
  if (cleaned.length !== 8) return false;

  const multipliers = [2, 9, 8, 7, 6, 3, 4];
  const digits = cleaned.split('').map(Number);
  const sum = multipliers.reduce((acc, multiplier, idx) => acc + multiplier * digits[idx], 0);
  const expectedCheckDigit = (10 - (sum % 10)) % 10;

  return digits[7] === expectedCheckDigit;
};

export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
